'use strict';

import {gsap} from 'gsap';

const $ = jQuery.noConflict();
$(function() {

	const heroCards = {

		init: function() {
			this.cacheDOM();
			this.initCarousel();
		},

		cacheDOM: function() {
			this.$carousel = $('.hero-cards__carousel');
			this.$carouselRows = $('.js-carousel-row');
		},

		initCarousel: function() {
			this.$carouselRows.each(function() {
				const $ticker = $(this);
				const $inner = $ticker.find('.js-carousel-wrap');
				const $content = $inner.find('.js-carousel-item-wrap');

				if (!$content.length) return;

				// Duration for one complete scroll cycle (in seconds)
				const duration = 120;

				// Clone the content to create seamless loop
				const $clone = $content.clone();
				$inner.append($clone);

				// Store animations for potential pause/play functionality
				const animations = [];

				// Animate each item wrapper
				$inner.find('.js-carousel-item-wrap').each(function() {
					const animation = gsap.to(this, {
						y: '-100%',
						repeat: -1,
						duration: duration,
						ease: 'linear'
					});
					animations.push(animation);
				});

				// Pause scrolling while hovering a card link
				$ticker.on('mouseenter', 'a', function() {
					animations.forEach(anim => anim.pause());
				});

				$ticker.on('mouseleave', 'a', function() {
					animations.forEach(anim => anim.resume());
				});
			});

			this.$carousel.addClass('is-ready');
		},

	};

	heroCards.init();
});
